export default __webpack_public_path__ + "static/media/Punto_01_Porto_Mediceo_FRA_Def.a96ba080.aac";